module.exports = __webpack_public_path__ + "static/media/nol.913c7fca.svg";